export const EmailAdminFilterKey = {
  Action: 'action',
  Status: 'status',
  Tag: 'tag',
} as const;
export type EmailAdminFilterKey = (typeof EmailAdminFilterKey)[keyof typeof EmailAdminFilterKey];
export const EMAIL_ADMIN_FILTER_KEYS = [
  EmailAdminFilterKey.Action,
  EmailAdminFilterKey.Status,
  EmailAdminFilterKey.Tag,
] as const;
